<div
  class="team-scoring-widget"
  [style.opacity]="opacity"
  [style.border-color]="borderColor"
  [style.border-width]="borderWidth + 'px'"
  [style.border-style]="borderStyle"
  [style.border-radius]="borderRadius"
  [style.--font-scale]="fontSizeScale"
  [style.--team-row-count]="rowCount"
  [style.font-family]="fontFamily"
  [style.font-weight]="fontWeight"
  [style.text-align]="textAlign"
>
  @let visibleTeamScores = visibleTeamScores$ | async;
  @if (visibleTeamScores && visibleTeamScores.length > 0) {
    @if (teamScoringWidget.transition === 'fade-in') {
      @let pageIndex = pageIndex$ | async;
      <div
        class="team-grid"
        [class.fade-in-even]="pageIndex !== null && pageIndex % 2 === 0"
        [class.fade-in-odd]="pageIndex !== null && pageIndex % 2 !== 0"
        [style.grid-template-columns]="'repeat(' + (teamScoringWidget.columns || 1) + ', minmax(0, 1fr))'"
        [style.grid-template-rows]="'repeat(' + (teamScoringWidget.rows || 1) + ', minmax(0, 1fr))'"
      >
        @for (teamScore of displayTeamScores$ | async; track teamScore.uuid) {
          <div class="team-scoring-row">
            <div class="team-name" [style.background-color]="accentColor" [style.color]="accentTextColor">
              {{ teamScore.name }}
            </div>
            <div class="team-score" [style.background-color]="primaryColor" [style.color]="primaryTextColor">
              {{ 'PRESENTER.TEAM_SCORING_TOOLS.TOTAL_RAISED' | translate: { score: (teamScore.score | gbCurrency) } }}
            </div>
          </div>
        }
      </div>
    }
    @if (
      teamScoringWidget.transition === 'scroll-left' ||
      teamScoringWidget.transition === 'scroll-right' ||
      teamScoringWidget.transition === 'scroll-up' ||
      teamScoringWidget.transition === 'scroll-down'
    ) {
      <div class="carousel-viewport">
        <div
          class="carousel-track"
          [class.scroll-left]="teamScoringWidget.transition === 'scroll-left'"
          [class.scroll-right]="teamScoringWidget.transition === 'scroll-right'"
          [class.scroll-up]="teamScoringWidget.transition === 'scroll-up'"
          [class.scroll-down]="teamScoringWidget.transition === 'scroll-down'"
          [style.--carousel-duration-ms]="(carouselLoopDurationMs$ | async) + 'ms'"
          [style.--carousel-translate-percent]="(carouselLoopTranslatePercent$ | async) + '%'"
        >
          @for (page of pagesLoop$ | async; track $index) {
            <div
              class="team-grid carousel-page"
              [style.grid-template-columns]="'repeat(' + (teamScoringWidget.columns || 1) + ', minmax(0, 1fr))'"
              [style.grid-template-rows]="'repeat(' + (teamScoringWidget.rows || 1) + ', minmax(0, 1fr))'"
            >
              @for (teamScore of page; track teamScore.uuid) {
                <div class="team-scoring-row">
                  <div class="team-name" [style.background-color]="accentColor" [style.color]="accentTextColor">
                    {{ teamScore.name }}
                  </div>
                  <div class="team-score" [style.background-color]="primaryColor" [style.color]="primaryTextColor">
                    {{
                      'PRESENTER.TEAM_SCORING_TOOLS.TOTAL_RAISED' | translate: { score: (teamScore.score | gbCurrency) }
                    }}
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <gb-presenter-widget-placeholder>
      <h1 translate="PRESENTER.TEAM_SCORING"></h1>
      <span translate="PRESENTER.TEAM_SCORING_TOOLS.NO_TEAMS"></span>
    </gb-presenter-widget-placeholder>
  }
</div>
